import React from 'react';
import { RentContractStyles } from './RentContractStyles';
import { TextWithDot } from '../../components/textWithDot/TextWithDot';
import { useAppSelector } from '../../state/hooks';
import getTranslationByLangOrUk from '../../utils/getTranslationByLangOrUk';
import Seo from '../../components/seo/Seo';

function RentContract() {
  const { interfaceLanguage } = useAppSelector((state) => state.languages);

  return (
    <>
      <Seo />

      <RentContractStyles>
        <div className="container firstContainer">
          <div className="titleWrapper firstSectionTitleWrapper">
            <div className="headWrapper">
              <h2 className="textH2 textExtraBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_1')}</h2>
              <h2 className="textH2 textExtraBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_2')}</h2>
            </div>

            <p className="textBase18">
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_3')}
            </p>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_4')}</h3>

            <div className="textContainer textBase18">
              <p>
                <span className="textBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_5')}</span>
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_6')}
              </p>

              <p>
                <span className="textBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_7')}</span>
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_8')}
              </p>

              <div className="listContainer">
                <p>
                  <span className="textBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_9')}</span>
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_10')}
                </p>

                <ul>
                  <li><TextWithDot text={getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_11')} /></li>
                  <li><TextWithDot text={getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_12')} /></li>
                  <li><TextWithDot text={getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_13')} /></li>
                  <li><TextWithDot text={getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_14')} /></li>
                </ul>
              </div>

              <div className="listContainer">
                <p className="textBold">
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_15')}
                </p>

                <ul>
                  <li><TextWithDot text={getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_16')} /></li>
                  <li><TextWithDot text={getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_17')} /></li>
                  <li><TextWithDot text={getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_18')} /></li>
                </ul>
              </div>

              <div className="listContainer">
                <p className="textBold">
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_19')}
                </p>

                <ul>
                  <li><TextWithDot text={getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_20')} /></li>
                  <li><TextWithDot text={getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_21')} /></li>
                  <li><TextWithDot text={getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_22')} /></li>
                </ul>
              </div>

              <p className="textBold">
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_23')}
              </p>

              <p>
                <span className="textBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_24')}</span>
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_25')}
              </p>

              <p>
                <span className="textBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_26')}</span>
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_27')}
              </p>

              <p>
                <span className="textBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_28')}</span>
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_29')}
              </p>

              <p>
                <span className="textBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_30')}</span>
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_31')}
              </p>

              <p>
                <span className="textBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_32')}</span>
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_33')}
                : https://realist.ua.
              </p>
            </div>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">
              1.
              {' '}
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_34')}
            </h3>
            <ul className="list">
              <li className="textBase18">
                <span className="textSemiBold">1.1</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_35')}
              </li>
              <li className="textBase18">
                <span className="textSemiBold">1.2</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_36')}
              </li>

              <li className="textBase18">
                <div>
                  <span className="textSemiBold">1.3</span>
                  {' '}
                  -
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_37')}
                </div>
              </li>
            </ul>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">
              2.
              {' '}
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_38')}
            </h3>
            <ul className="list">
              <li className="textBase18">
                <span className="textSemiBold">2.1</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_39')}
              </li>
              <li className="textBase18">
                <span className="textSemiBold">2.2</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_40')}
              </li>

              <li className="textBase18">
                <div>
                  <span className="textSemiBold">2.3</span>
                  {' '}
                  -
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_41')}
                </div>
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.4</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_42')}

                <ul className="innerList">
                  <li className="textBase18">
                    <span className="textSemiBold">2.4.1</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_43')}
                  </li>
                  <li className="textBase18">
                    <span className="textSemiBold">2.4.2</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_44')}
                  </li>
                  <li className="textBase18">
                    <span className="textSemiBold">2.4.3</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_45')}
                  </li>
                  <li className="textBase18">
                    <span className="textSemiBold">2.4.4</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_46')}
                  </li>
                </ul>
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.5</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_47')}
                <ul className="innerList">
                  <li className="textBase18">
                    <span className="textSemiBold">2.5.1</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_48')}
                  </li>
                  <li className="textBase18">
                    <span className="textSemiBold">2.5.2</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_49')}
                  </li>
                  <li className="textBase18">
                    <span className="textSemiBold">2.5.3</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_50')}
                  </li>
                  <li className="textBase18">
                    <span className="textSemiBold">2.5.4</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_51')}
                  </li>
                </ul>
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.6</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_52')}
              </li>
              <li className="textBase18">
                <span className="textSemiBold">2.7</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_53')}
              </li>
            </ul>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">
              3.
              {' '}
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_54')}
            </h3>
            <ul className="list">
              <li className="textBase18">
                <span className="textSemiBold">3.1</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_55')}

                <ul className="innerList">
                  <li>
                    <span className="textSemiBold">3.1.1</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_56')}
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">
              4.
              {' '}
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_57')}
            </h3>
            <ul className="list">
              <li className="textBase18">
                <span className="textSemiBold">
                  4.1 -
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_58')}
                </span>

                <ul className="innerList">
                  <li>
                    <span className="textSemiBold">4.1.1</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_59')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.1.2</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_60')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.1.3</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_61')}
                  </li>
                </ul>
              </li>
              <li className="textBase18">
                <span className="textSemiBold">
                  4.2 -
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_62')}
                </span>

                <ul className="innerList">
                  <li>
                    <span className="textSemiBold">4.2.1</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_63')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.2.2</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_64')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.2.3</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_65')}
                  </li>
                </ul>
              </li>
              <li className="textBase18">
                <span className="textSemiBold">
                  4.3 -
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_66')}
                </span>

                <ul className="innerList">
                  <li>
                    <span className="textSemiBold">4.3.1</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_67')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.3.2</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_68')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.3.3</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_69')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.3.4</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_70')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.3.5</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_71')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.3.6</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_72')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.3.7</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_73')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.3.8</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_74')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.3.9</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_75')}
                  </li>
                </ul>
              </li>
              <li className="textBase18">
                <span className="textSemiBold">
                  4.4.
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_76')}
                </span>

                <ul className="innerList">
                  <li>
                    <span className="textSemiBold">4.4.1</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_77')}
                  </li>
                  <li>
                    <span className="textSemiBold">4.4.2</span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_78')}
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">
              5.
              {' '}
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_79')}
            </h3>
            <ul className="list">
              <li className="textBase18">
                <span className="textSemiBold">5.1</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_80')}
              </li>
              <li className="textBase18">
                <span className="textSemiBold">5.2</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_81')}
              </li>

              <li className="textBase18">
                <div>
                  <span className="textSemiBold">5.3</span>
                  {' '}
                  -
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_82')}
                  <br />
                  <span className="textSemiBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_83')}</span>
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_84')}
                  {' '}
                  <span className="textSemiBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_85')}</span>
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_86')}
                </div>
              </li>

              <li className="textBase18">
                <div>
                  <span className="textSemiBold">5.4</span>
                  {' '}
                  -
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_87')}
                </div>
              </li>

              <li className="textBase18">
                <div>
                  <span className="textSemiBold">5.5</span>
                  {' '}
                  -
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_88')}
                </div>
              </li>
            </ul>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">
              6.
              {' '}
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_89')}
            </h3>
            <ul className="list">
              <li className="textBase18">
                <span className="textSemiBold">6.1</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_90')}
              </li>
              <li className="textBase18">
                <span className="textSemiBold">6.2</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_91')}
              </li>

              <li className="textBase18">
                <div>
                  <span className="textSemiBold">6.3</span>
                  {' '}
                  -
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_92')}
                </div>
              </li>
            </ul>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">
              7.
              {' '}
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_93')}
            </h3>
            <ul className="list">
              <li className="textBase18">
                <span className="textSemiBold">7.1</span>
                {' '}
                -
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_94')}
              </li>
            </ul>
          </div>
        </div>

        <div className="container">
          <div className="rightSideTitle">
            <h3 className="textH3 textExtraBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_95')}</h3>
            <h3 className="textH3 textExtraBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_96')}</h3>
            <h3 className="textH3 textExtraBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_97')}</h3>
          </div>

          <div className="titleWrapper">
            <div className="headWrapper">
              <h3 className="textH3 textExtraBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_98')}</h3>
              <h3 className="textH3 textExtraBold">{getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_99')}</h3>
            </div>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">
              1.
              {' '}
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_100')}
            </h3>
            <ul className="list">
              <li className="textBase18">
                <span className="textSemiBold">1.1</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_101')}
              </li>
              <li className="textBase18">
                <span className="textSemiBold">1.2</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_102')}
              </li>

              <li className="textBase18">
                <div>
                  <span className="textSemiBold">1.3</span>
                  {' '}
                  -
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_103')}
                </div>
              </li>

              <li className="textBase18">
                <div>
                  <span className="textSemiBold">1.4</span>
                  {' '}
                  -
                  {' '}
                  {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_104')}
                </div>
              </li>
            </ul>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">
              2.
              {' '}
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_105')}
            </h3>
            <ul className="list">
              <li className="textBase18">
                <span className="textSemiBold">2.1</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_106')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.2</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_107')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.3</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_108')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.4</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_109')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.5</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_110')}
                <br />
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_111')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.6</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_112')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.7</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_113')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.8</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_114')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.9</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_115')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.10</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_116')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.11</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_117')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.12</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_118')}
                <br />
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_119')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.13</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_120')}
              </li>

              <li className="textBase18">
                <span className="textSemiBold">2.14</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_121')}
              </li>
            </ul>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">
              3.
              {' '}
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_122')}
            </h3>
            <ul className="list">
              <li className="textBase18">
                <span className="textSemiBold">3.1</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_123')}

                <ul className="innerList">
                  <li className="textBase18">
                    <span className="textSemiBold">
                      {getTranslationByLangOrUk(interfaceLanguage, 'rule')}
                      {' '}
                      №1
                    </span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_124')}
                  </li>

                  <li className="textBase18">
                    <span className="textSemiBold">
                      {getTranslationByLangOrUk(interfaceLanguage, 'rule')}
                      {' '}
                      №2
                    </span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_125')}
                  </li>

                  <li className="textBase18">
                    <span className="textSemiBold">
                      {getTranslationByLangOrUk(interfaceLanguage, 'rule')}
                      {' '}
                      №3
                    </span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_126')}
                  </li>

                  <li className="textBase18">
                    <span className="textSemiBold">
                      {getTranslationByLangOrUk(interfaceLanguage, 'rule')}
                      {' '}
                      №4
                    </span>
                    {' '}
                    -
                    {' '}
                    {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_127')}
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="listWrapper">
            <h3 className="textH3 textExtraBold">
              4.
              {' '}
              {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_128')}
            </h3>
            <ul className="list">
              <li className="textBase18">
                <span className="textSemiBold">4.1</span>
                {' '}
                -
                {' '}
                {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_129')}
              </li>
            </ul>
          </div>

          <p className="textBase18">
            {getTranslationByLangOrUk(interfaceLanguage, 'rent_contract_130')}
          </p>
        </div>
      </RentContractStyles>
    </>
  );
}

export default RentContract;
